/* istanbul ignore file */
export default
`<div>
    <ejs-dashboardlayout :created="dynamicLayoutCreated" id="defaultLayout" :allowDragging="editorEnabled" :columns="6" :panels="dynamicPositions" :change="changePanelPositions">
    </ejs-dashboardlayout>
    <div v-if="showAdjustablePanelContent">
        <teleport v-for="(position, index) in positions" :to="dynamicPositions[index].contentId">
            <div>
                <div v-for="component in position.components" >
                    <component 
                        v-bind="componentMappedProps[component.cId]" 
                        :is="component.cType" 
                        :cId="component.cId" 
                        :editor-enabled="editorEnabled"
                        v-if="displayedComponents[component.cId]" 
                        v-show="showedComponents[component.cId]" 
                        :unique-store-id="uniqueStoreId"
                        class="layout-component"
                        :ref="'ref__' + component.cId"
                    ></component>
                </div>
            </div>
        </teleport>
    </div>
</div>`;
